import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { Failure } from "../../../core/failure";
import { ICRUDRepo } from "../../../core/models";
import { getClientHistoryList, getFilterDate } from "../util";
import { clientHistoryFromJson, clientHistoryToJson, IClientHistory } from "./entities";

interface IClientHistoryRepo extends ICRUDRepo<IClientHistory, {}> {
  getHistoryList: (searchQuery?: string) => Promise<IClientHistory[]>;
}

const URL = "v1/client-history";

const ClientHistoryRepoImplFactory = (apiClient: ApiClient): IClientHistoryRepo => {
  const r: IClientHistoryRepo = {
    ...generateCrudRepoFactory<IClientHistory, {}>(apiClient, URL, clientHistoryFromJson, clientHistoryToJson),
    getHistoryList: async (searchQuery) => {
      try {
        const res = await apiClient.get(`/${URL}`);
        const p: IClientHistory[] = res.data.map(clientHistoryFromJson);
        const date = getFilterDate(searchQuery);
        const list = getClientHistoryList(p, date);
        return list;
      } catch (error) {
        const failure: Failure = {
          message: error.message ?? "Unhandled failure",
        };
        throw failure;
      }
    },
  };

  return r;
};

export const ClientHistoryRepoImpl = ClientHistoryRepoImplFactory(apiClient);
